export interface DirectoryProfile {
    username: string;
    displayName: string;
    city?: string;
    place?: string;
    skills?: string[];
    href: string;
    headline?: string;
}

export interface DirectorySkill {
    slug: string;
    displayName: string;
    count: number;
    href: string;
}

export interface DirectoryResponse {
    documentTitle?: string;
    h1?: string;
    summary?: string;
    skills?: DirectorySkill[];
    profiles?: DirectoryProfile[];
    places?: Array<{ slug: string; displayName: string; count: number }>;
    skill?: { slug: string; displayName: string } | null;
    place?: { slug: string; displayName: string } | null;
    total?: number;
    page?: number;
    pageCount?: number;
    metaDescription?: string;
    canonicalUrl?: string;
    robots?: string;
    prevUrl?: string;
    nextUrl?: string;
    jsonLd?: unknown;
}

const DATA_SCRIPT_ID = 'jamwith-seo-data';

export function directoryPublicPath(skillSlug?: string, placeSlug?: string): string {
    return ['/directory', skillSlug, placeSlug]
        .filter((part): part is string => Boolean(part))
        .map((part) => part.toLowerCase())
        .join('/');
}

function pageNumber(page?: string | null): string {
    if (!page || page === '1') return '1';
    return page;
}

/** The directory document the edge worker already wrote into this page, when it matches the URL. */
export function readEmbeddedDirectory(
    skillSlug?: string,
    placeSlug?: string,
    page?: string | null,
): DirectoryResponse | null {
    if (typeof document === 'undefined') return null;
    const raw = document.getElementById(DATA_SCRIPT_ID)?.textContent;
    if (!raw) return null;
    let data: DirectoryResponse;
    try {
        data = JSON.parse(raw) as DirectoryResponse;
    } catch {
        return null;
    }
    if (!data?.canonicalUrl || !Array.isArray(data.profiles)) return null;
    let url: URL;
    try {
        url = new URL(data.canonicalUrl);
    } catch {
        return null;
    }
    if (url.pathname.toLowerCase() !== directoryPublicPath(skillSlug, placeSlug)) return null;
    if ((url.searchParams.get('page') || '1') !== pageNumber(page)) return null;
    return data;
}
